import React from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StorageIcon from '@mui/icons-material/Storage';

/**
 * Card hiển thị một loại nguồn (MongoDB, Postgres, MinIO, Firebase) và danh sách nguồn đã cấu hình.
 */
const SourceTypeCard = ({
    sourceType,
    sources = [],
    onAdd,
    onEdit,
    onDelete,
    onViewData
}) => {
    const isEmpty = !sources || sources.length === 0;

    return (
        <Card
            variant="outlined"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderLeft: `4px solid ${sourceType.color || '#666'}`
            }}
        >
            <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: 1,
                                bgcolor: `${sourceType.color}20`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <StorageIcon sx={{ color: sourceType.color, fontSize: 24 }} />
                        </Box>
                        <Typography variant="h5" fontWeight={600}>
                            {sourceType.label}
                        </Typography>
                    </Box>
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => onAdd(sourceType.id)}
                        sx={{ bgcolor: sourceType.color, '&:hover': { bgcolor: sourceType.color, opacity: 0.9 } }}
                    >
                        Thêm nguồn
                    </Button>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {sourceType.description}
                </Typography>

                {isEmpty ? (
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: 80,
                            bgcolor: 'grey.50',
                            borderRadius: 1,
                            border: '1px dashed',
                            borderColor: 'grey.300'
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            Chưa cấu hình nguồn nào
                        </Typography>
                    </Box>
                ) : (
                    <List dense disablePadding>
                        {sources.map((s) => (
                            <ListItem
                                key={s.id}
                                sx={{
                                    borderBottom: '1px solid',
                                    borderColor: 'divider',
                                    '&:last-child': { borderBottom: 'none' }
                                }}
                            >
                                <ListItemText
                                    primary={s.name}
                                    secondary={s.config?.database || s.config?.bucket || s.config?.endpoint || ''}
                                    primaryTypographyProps={{ fontWeight: 500 }}
                                />
                                <ListItemSecondaryAction>
                                    <IconButton size="small" onClick={() => onEdit(s)} title="Sửa" aria-label="Sửa">
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => onViewData(s)} title="Xem dữ liệu" aria-label="Xem dữ liệu">
                                        <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => onDelete(s)} color="error" title="Xóa" aria-label="Xóa">
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                )}
            </CardContent>
        </Card>
    );
};

export default SourceTypeCard;
